import { Stack, Typography } from "@material-ui/core";
import { Box } from "@material-ui/system";
import arrowIcon from "src/assets/images/icon_arrow_right_white.svg";
import { CustomRouterLink } from "./CustomRouterLink";
import arrow_right from "src/assets/images/Arrow_right.svg";
import rectangle from "src/assets/images/rectangle.png";
import rectangle2 from "src/assets/images/rectangle2.png";

export const Web3ToolBuilder = () => {


    return (
        <Box p="50px 40px 74px">
            <Box display="flex" alignItems="center">
                <img src={arrow_right} style={{ width: "36px", height: "36px", marginRight: "10px" }} />
                <Typography fontSize="30px" variant="bold" color="#FFFFFF">
                    A Web3 Tool Builder
                </Typography>
            </Box>
            <Box display="flex" alignItems="center" justifyContent="space-between">
                <Typography fontSize="16px" color="secondary" mt="15px">
                    Simply delegate your tokens using Wetez wallet
                </Typography>
                {/* <CustomRouterLink to="/stakingPools">
                    <Box border="1px solid #C2C2C2" padding="9px 19px" display="flex" justifyContent="flex-end">
                        <Stack direction="row">
                            <Typography
                                fontSize="16px"
                                color="secondary"
                                sx={{
                                    textDecoration: "none",
                                }}
                            >
                                See more
                            </Typography>

                            <Box width="7px" ml="8px">
                                <img src={arrowIcon} width="100%" alt="icon" />
                            </Box>
                        </Stack>
                    </Box>
                </CustomRouterLink> */}
            </Box>

            <Box
                mt="60px"
                sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2, 567px)",
                    rowGap: "50px",
                    justifyContent: "space-between",
                    alignItems: "space-between"
                }}
            >
                <Box
                    display="flex"
                    alignItems="center"
                    borderRadius="3px"
                    width="567px"
                    p="30px 50px 50px 30px"
                    sx={{
                        backgroundColor: "#FFFFFF",
                    }}
                >
                    <img src={rectangle} />
                    <Box pl="30px" >

                        <Typography fontSize="26px" color="#0E1011" variant="bold" mt="128px">
                            Stakeshot
                        </Typography>
                        <Typography fontSize="16px" color="#6D6D6D" mt="10px">
                            An opensource snapshot
                            tool of staker
                        </Typography>
                        <CustomRouterLink to="/stakeshot">
                            <Box width={"fit-content"} border="1px solid #C2C2C2" mt="30px" padding="12px 32px" display="flex">
                                <Stack direction="row">
                                    <Typography
                                        fontSize="20px"
                                        color="#616161"
                                        sx={{
                                            textDecoration: "none",
                                        }}
                                    >
                                        Coming Soon
                                    </Typography>
                                </Stack>
                            </Box>
                        </CustomRouterLink>
                    </Box>
                </Box>

                <Box
                    display="flex"
                    alignItems="center"
                    borderRadius="3px"
                    width="567px"
                    p="30px 50px 50px 30px"
                    sx={{
                        backgroundColor: "#FFFFFF",
                    }}
                >
                    <img src={rectangle2} />
                    <Box pl="30px" >

                        <Typography fontSize="26px" color="#0E1011" variant="bold" mt="128px">
                            Staking Wallet
                        </Typography>
                        <Typography fontSize="16px" color="#6D6D6D" mt="10px">
                            Simply delegate your tokens using Wetez wallet
                        </Typography>
                        <CustomRouterLink to="/wallet">
                            <Box width={"188px"} justifyContent="center" border="1px solid #C2C2C2" mt="30px" padding="12px 32px" display="flex">
                                <Stack direction="row">
                                    <Typography
                                        fontSize="20px"
                                        color="#616161"
                                        sx={{
                                            textDecoration: "none",
                                        }}
                                    >
                                        App
                                    </Typography>
                                </Stack>
                            </Box>
                        </CustomRouterLink>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};
